import { Component, OnInit, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, RowNode } from 'ag-grid-community';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { EditEqBkCalcPopupComponent } from '../edit-eq-bk-calc-popup/edit-eq-bk-calc-popup.component';

@Component({
  selector: 'app-edit-eq-bk-calc',
  templateUrl: './edit-eq-bk-calc.component.html',
  styleUrls: ['./edit-eq-bk-calc.component.css']
})
export class EditEqBkCalcComponent implements ICellRendererAngularComp {
  public params: any;
  isEditVisible: boolean = false;
  gridApi: any;
  countryCode: any;
  DatafromEQ: any;
  refDataFromEQ: any;
  configDatafromEQ: any;
  refOverhead: any;
  refLabour: any;
  title: string;
  scenarioType: string;
  typeOfCost: string;
  refGridApi: any;
  overhead: any;
  labour: any;
  mek: any;
  asseblyGroupedData: any[];
  getConfigGridData: () => any[];
  configurationid: any;
  getSimulationData: () => any[];
  getLatestOverheadData: () => any[];
  filteredSimulationData: any[];
  userId: any;
  hasMinorAccess: () => any[];

  constructor(
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any) {
    this.params = params;
    this.gridApi = params.api;
    this.DatafromEQ = params.customInput;
    this.countryCode = this.localStorageService.get('countryCode');
    if (!this.params.node.group && this.params.data.Name === "BK") {
      this.isEditVisible = this.params.data.IsEditable;
    } else {
      this.isEditVisible = false;
    }
    // this.refDataFromEQ = this.DatafromEQ.RefGridDataFromEQ;
    // this.refDataFromEQ.setRowGroupColumns(['Assembly']);
    // const cloned = this.cleanClone(this.DatafromEQ.ConfigGridDataFromEQ);
    // this.refGridApi = this.DatafromEQ.RefGridDataFromEQ;
    // this.refGridApi = this.DatafromEQ.ConfigGridDataFromEQ;
    this.configurationid = this.DatafromEQ.ConfigurationId;
    this.userId = this.DatafromEQ.UserId;
    this.getConfigGridData = this.DatafromEQ.getLatestConfigData || (() => []);
    this.getSimulationData = this.DatafromEQ.getLatestSimulationData || (() => []);
    this.getLatestOverheadData = this.DatafromEQ.getOverheadData || (() => Number);
    this.hasMinorAccess = this.DatafromEQ.HasMinorAccess || (() => Boolean);
    // this.asseblyGroupedData = this.getGroupedDataByAssembly(this.DatafromEQ.ConfigGridDataFromEQ)
  }

  editData(params: any) {
    const latestConfigData = this.getConfigGridData();
    const accessibleAssemblies = latestConfigData
      .filter(row => row.IsDisplayAssembly)
      .map(row => row.Assembly !== undefined ? row.Assembly : '');
    const assemblyAccessMap = {};
    latestConfigData.forEach(row => {
      const assemblyKey = row.Assembly !== undefined ? row.Assembly : '';
      assemblyAccessMap[assemblyKey] = row.IsReadOrWriteAccess
        ? 'readwrite'
        : (row.IsReadAccess ? 'read' : 'none');
    });
    const SimulationData = this.getSimulationData();
    // Use the fresh data to calculate assembly groups
    // this.asseblyGroupedData = this.getGroupedDataByAssembly(latestConfigData);
    this.asseblyGroupedData = this.getGroupedDataByAssembly(latestConfigData);

    // Set isActive = false for assemblies where all rows are inactive
    this.asseblyGroupedData.forEach(group => {
      const rows = latestConfigData.filter(row => row.Assembly === group.Assembly);
      if (rows.length > 0 && rows.every(row => row.IsActive === false)) {
        group.IsActive = false;
      } else {
        group.IsActive = true;
      }
    });

    const latestConfigAssemblies = Array.from(new Set(latestConfigData.map(row => row.Assembly || '')));
    SimulationData.forEach(item => {
      // If assembly is not present in latest config assemblies
      if (!["Total", "Labour", "Overhead", "Assembly group"].includes(item.Name) && !latestConfigAssemblies.includes(item.Name)) {
        item.IsRemoved = true;
        if (item.Id > 0) {
          item.IsActive = false;
          item.UserId = this.userId;
        }
      }
    });


    const safeValue = (val: any) => (val === null || val === undefined || val === "" ? 0 : val);

    this.refOverhead = safeValue(this.getLatestOverheadData());
    this.gridApi.forEachNode(node => {
      // if (node.data.Name === "Overhead" && node.data.Description === "therein Overhead") {
      //   this.refOverhead = safeValue(node.data.ReferenceScenario.PerSystem);
      // }
      if (node.data.Name === "Labour" && node.data.Description === "therein Labour") {
        this.refLabour = safeValue(node.data.ReferenceScenario.PerSystem);
      }
    })
    if (!this.params.node.group && this.params.column.colId == "tc") {
      this.title = "Target Scenario";
      this.scenarioType = "Target";
      this.typeOfCost = "Target";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'TargetScenario', 'TargetCostMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });


      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'Target' && item.TypeOfCost === 'Target') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.TargetScenario.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.TargetScenario.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.TargetScenario.TargetCost.PerSystem);
        }
      })
    }
    if (!this.params.node.group && this.params.column.colId == "fc") {
      this.title = "Target Scenario";
      this.scenarioType = "Target";
      this.typeOfCost = "Forecast";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'TargetScenario', 'ForecastMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'Target' && item.TypeOfCost === 'Forecast') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.TargetScenario.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.TargetScenario.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.TargetScenario.Forecast.PerSystem);
        }
      })
    }
    if (!this.params.node.group && this.params.column.colId == "tcOptA") {
      this.title = "Opt A";
      this.scenarioType = "OptionA";
      this.typeOfCost = "Target";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionA', 'TargetCostMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionA' && item.TypeOfCost === 'Target') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionA.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionA.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionA.TargetCost.PerSystem);
        }
      })
    }

    if (!this.params.node.group && this.params.column.colId == "fcOptA") {
      this.title = "Opt A";
      this.scenarioType = "OptionA";
      this.typeOfCost = "Forecast";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionA', 'ForecastMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionA' && item.TypeOfCost === 'Forecast') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionA.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionA.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionA.Forecast.PerSystem);
        }
      })
    }

    if (!this.params.node.group && this.params.column.colId == "tcOptB") {
      this.title = "Opt B";
      this.scenarioType = "OptionB";
      this.typeOfCost = "Target";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionB', 'TargetCostMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });


      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionB' && item.TypeOfCost === 'Target') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionB.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionB.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionB.TargetCost.PerSystem);
        }
      })
    }

    if (!this.params.node.group && this.params.column.colId == "fcOptB") {
      this.title = "Opt B";
      this.scenarioType = "OptionB";
      this.typeOfCost = "Forecast";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionB', 'ForecastMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionB' && item.TypeOfCost === 'Forecast') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionB.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionB.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionB.TargetCost.PerSystem);
        }
      })
    }

    if (!this.params.node.group && this.params.column.colId == "tcOptC") {
      this.title = "Opt C";
      this.scenarioType = "OptionC";
      this.typeOfCost = "Target";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionC', 'TargetCostMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionC' && item.TypeOfCost === 'Target') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionC.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionC.TargetCost.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionC.TargetCost.PerSystem);
        }
      })
    }

    if (!this.params.node.group && this.params.column.colId == "fcOptC") {
      this.title = "Opt C";
      this.scenarioType = "OptionC";
      this.typeOfCost = "Forecast";

      // Calculate for TargetScenario.TargetCostMEK
      const targetTotals = this.getGroupedDataByAssemblyForScenario(latestConfigData, 'OptionC', 'ForecastMEK');
      // Append to assemblyGroupedData
      this.asseblyGroupedData.forEach(group => {
        const found = targetTotals.find(t => t.Assembly === group.Assembly);
        group.TargetTotalMEKPerSystem = found ? found.TotalMEKPerSystem : 0;
      });

      this.filteredSimulationData = SimulationData?.filter(item => (item.ScenarioType === 'OptionC' && item.TypeOfCost === 'Forecast') || item.ScenarioType === 'Reference');
      this.filteredSimulationData = this.filteredSimulationData.filter(item =>
        !(item.IsActive === false && item.IsRemoved === true)
      );

      this.gridApi.forEachNode(node => {
        if (node.data.Name === "MEKOverhead" && node.data.Description === "therein Overhead") {
          this.overhead = safeValue(node.data.OptionC.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKLabour" && node.data.Description === "therein Labour") {
          this.labour = safeValue(node.data.OptionC.Forecast.PerSystem);
        }
        if (node.data.Name === "MEKMEKTotal" && node.data.Description === "therein Labour") {
          this.mek = safeValue(node.data.OptionC.Forecast.PerSystem);
        }
      })
    }

    let dialogRef = this.dialog.open(EditEqBkCalcPopupComponent, {
      height: '55%',
      width: '60%',
      panelClass: 'kmat-dialog-container',
      data: {
        Title: this.title,
        Scenariotype: this.scenarioType,
        TypeOfCost: this.typeOfCost,
        ConfigurationId: this.configurationid,
        RefOverhead: this.refOverhead,
        RefLabour: this.refLabour,
        Overhead: this.overhead,
        Labour: this.labour,
        MEK: this.mek,
        AssemblyData: this.asseblyGroupedData,
        SimulationData: this.filteredSimulationData,
        UserId: this.userId,
        AccessibleAssemblies: accessibleAssemblies,
        AssemblyAccessMap: assemblyAccessMap,
        HasMinorAccess: this.hasMinorAccess(),
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result != "" && result != null) {

        const updated = result.SimulationData;
        const mergedSimulationData = [...SimulationData];

        // Merge updated data into existing simulation data
        updated.forEach((item: any) => {
          if (this.hasMinorAccess() && accessibleAssemblies.length > 0) {
            // const accessibleAssemblies = accessibleAssemblies;
            // Allow updates for "Total", "Overhead", "Assembly group" and accessible assemblies
            if (
              !accessibleAssemblies.includes(item.Name !== undefined ? item.Name : '')
            ) {
              // Skip updating this item
              return;
            }
          }
          const existingIndex = mergedSimulationData.findIndex(
            (existingItem: any) => existingItem.ConfigurationId === item.ConfigurationId && existingItem.Name === item.Name && existingItem.ScenarioType === item.ScenarioType && existingItem.TypeOfCost === item.TypeOfCost
          );
          if (existingIndex > -1) {
            mergedSimulationData[existingIndex] = item;
          } else {
            mergedSimulationData.push(item);
          }
        });

        if (result.SimulationData) {
          this.params.context.onSimulationDataUpdate(mergedSimulationData);
        }

        if (!this.params.node.group && this.params.column.colId == "tc") {
          this.gridApi.getDisplayedRowAtIndex(3).data.TargetScenario.TargetCost.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.TargetScenario.TargetCost.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.TargetScenario.TargetCost.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "fc") {
          this.gridApi.getDisplayedRowAtIndex(3).data.TargetScenario.Forecast.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.TargetScenario.Forecast.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.TargetScenario.Forecast.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "tcOptA") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionA.TargetCost.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionA.TargetCost.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionA.TargetCost.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptA") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionA.Forecast.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionA.Forecast.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionA.Forecast.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "tcOptB") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionB.TargetCost.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionB.TargetCost.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionB.TargetCost.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptB") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionB.Forecast.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionB.Forecast.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionB.Forecast.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "tcOptC") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionC.TargetCost.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionC.TargetCost.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionC.TargetCost.PerSystem = result.MEKMEKTotal;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptC") {
          this.gridApi.getDisplayedRowAtIndex(3).data.OptionC.Forecast.PerSystem = result.MEKOverhead;
          this.gridApi.getDisplayedRowAtIndex(4).data.OptionC.Forecast.PerSystem = result.MEKLabour;
          this.gridApi.getDisplayedRowAtIndex(5).data.OptionC.Forecast.PerSystem = result.MEKMEKTotal;
        }
        this.gridApi.refreshCells({ force: true });
        this.gridApi.redrawRows();
      }
    })
  }

  // getGroupedDataByAssembly(): any[] {
  //   const groupedDataMap = new Map<string, any>();

  //   this.refGridApi.forEachNode((node) => {
  //     const data = node.data;
  //     if (!node.group && data && data.ReferencceScenario) {
  //       const assemblyKey = data.Assembly || 'Unknown';

  //       // Check for IsActive (nullable logic)
  //       const isActive = data.IsActive == null || data.IsActive === true;
  //       if (!isActive) return;

  //       // Calculate MEKPerSystem as per logic
  //       let mekPerSystem = data.ReferencceScenario.MEKPerSystem;
  //       if (data.Component === data.Material) {
  //         // Custom aggregation
  //         let total = 0;
  //         let count = 0;
  //         this.refGridApi.forEachNode((innerNode) => {
  //           const innerData = innerNode.data;
  //           if (!innerNode.group && innerData &&
  //             innerData.Assembly === data.Assembly &&
  //             innerData.VBLO === data.VBLO &&
  //             innerData.Component === data.Component &&
  //             innerData.Component !== innerData.Material) {
  //             count++;
  //             total += innerData.ReferencceScenario?.MEKPerSystem || 0;
  //           }
  //         });

  //         mekPerSystem = count === 0
  //           ? (data.ReferencceScenario.MEKsPerPiece || 0) *
  //           (data.ReferencceScenario.Quantity || 0) *
  //           (data.ReferencceScenario.Weight || 0)
  //           : total;
  //       } else {
  //         mekPerSystem = (data.ReferencceScenario.MEKsPerPiece || 0) *
  //           (data.ReferencceScenario.Quantity || 0) *
  //           (data.ReferencceScenario.Weight || 0);
  //       }

  //       // Aggregate by assembly
  //       if (!groupedDataMap.has(assemblyKey)) {
  //         groupedDataMap.set(assemblyKey, {
  //           Assembly: assemblyKey,
  //           TotalMEKPerSystem: 0
  //         });
  //       }

  //       const current = groupedDataMap.get(assemblyKey);
  //       current.TotalMEKPerSystem += mekPerSystem;
  //     }
  //   });

  //   return Array.from(groupedDataMap.values());
  // }

  getGroupedDataByAssembly(gridData): any[] {
    const groupedDataMap = new Map<string, any>();

    gridData.forEach((data: any) => {
      if (!data || !data.ReferencceScenario) return;

      // Handle IsActive as nullable: if null or true, it's active
      const isActive = data.IsActive == null || data.IsActive === true;
      if (!isActive || data.HasChild) return;

      const assemblyKey = data.Assembly || '';
      let mekPerSystem = 0;

      // Logic for MEKPerSystem
      if (data.Component === data.Material) {
        // Find children with same Assembly, VBLO, Component but Material ≠ Component
        let total = 0;
        let count = 0;

        gridData.forEach(innerData => {
          if (!innerData || !innerData.ReferencceScenario) return;

          if (
            innerData.Assembly === data.Assembly &&
            innerData.VBLO === data.VBLO &&
            innerData.Component === data.Component &&
            innerData.Component !== innerData.Material
          ) {
            count++;
            total += innerData.ReferencceScenario.MEKPerSystem || 0;
          }
        });

        mekPerSystem =
          count === 0
            ? (data.ReferencceScenario.MEKsPerPiece || 0) *
            (data.ReferencceScenario.Quantity || 0) *
            (data.ReferencceScenario.Weight || 0)
            : total;

      } else {
        // Standard calculation
        mekPerSystem =
          (data.ReferencceScenario.MEKsPerPiece || 0) *
          (data.ReferencceScenario.Quantity || 0) *
          (data.ReferencceScenario.Weight || 0);
      }

      // Aggregate MEKPerSystem by Assembly
      if (!groupedDataMap.has(assemblyKey)) {
        groupedDataMap.set(assemblyKey, {
          Assembly: assemblyKey,
          TotalMEKPerSystem: 0
        });
      }

      const current = groupedDataMap.get(assemblyKey);
      current.TotalMEKPerSystem += mekPerSystem;
    });

    return Array.from(groupedDataMap.values());
  }

  getGroupedDataByAssemblyForScenario(
    gridData: any[],
    scenarioKey: string,
    typeOfCost: string
  ): any[] {
    const groupedDataMap = new Map<string, any>();

    gridData.forEach((data: any) => {
      const scenarioObj = data?.[scenarioKey]?.[typeOfCost];
      const targetCostObj = data?.[scenarioKey]?.['TargetCostMEK'];
      if (!data || !scenarioObj || !targetCostObj) return;

      // Handle IsActive as nullable: if null or true, it's active
      const isActive = data.IsActive == null || data.IsActive === true;
      if (!isActive || data.HasChild) return;

      const assemblyKey = data.Assembly || '';
      let mekPerSystem = 0;

      // Always use Quantity and Weight from TargetCostMEK
      const quantity = Number(targetCostObj.Quantity) || 0;
      const weight = Number(targetCostObj.Weight) || 0;
      const perPiece = Number(scenarioObj.PerPiece) || 0;
      const perSystem = Number(scenarioObj.PerSystem) || 0;

      if (data.Component === data.Material) {
        let total = 0;
        let count = 0;

        gridData.forEach(innerData => {
          const innerScenarioObj = innerData?.[scenarioKey]?.[typeOfCost];
          const innerTargetCostObj = innerData?.[scenarioKey]?.['TargetCostMEK'];
          if (!innerData || !innerScenarioObj || !innerTargetCostObj) return;

          if (
            innerData.Assembly === data.Assembly &&
            innerData.VBLO === data.VBLO &&
            innerData.Component === data.Component &&
            innerData.Component !== innerData.Material
          ) {
            count++;
            total += Number(innerScenarioObj.PerSystem) || 0;
          }
        });

        mekPerSystem =
          count === 0
            ? perPiece * quantity * weight
            : total;

      } else {
        mekPerSystem = perPiece * quantity * weight;
      }

      if (!groupedDataMap.has(assemblyKey)) {
        groupedDataMap.set(assemblyKey, {
          Assembly: assemblyKey,
          TotalMEKPerSystem: 0
        });
      }

      const current = groupedDataMap.get(assemblyKey);
      current.TotalMEKPerSystem += mekPerSystem;
    });

    return Array.from(groupedDataMap.values());
  }


  // calculateMekPerSystemGroup(rowData) {
  //   // Group data by Assembly
  //   const groups = new Map();

  //   // Helper to calculate MEKPerSystem for a single leaf row, same logic as your valueGetter

  //   // First, calculate MEKPerSystem for each row (like valueGetter)
  //   rowData.forEach(row => {
  //     if (row?.ReferencceScenario) {
  //       row.ReferencceScenario.MEKPerSystem = this.calculateMekPerSystemForRow(row, rowData);
  //     }
  //   });

  //   // Group rows by Assembly and sum MEKPerSystem for each group
  //   rowData.forEach(row => {
  //     if (row) {
  //       if (!groups.has(row.Assembly)) {
  //         groups.set(row.Assembly, {
  //           Assembly: row.Assembly,
  //           MEKPerSystemTotal: 0,
  //           rows: [],
  //         });
  //       }
  //       const group = groups.get(row.Assembly);

  //       // Only add MEKPerSystem if row is active and has no child (adapt as needed)
  //       if (
  //         (row.IsActive === null || row.IsActive === true) &&
  //         !row.HasChild
  //       ) {
  //         group.MEKPerSystemTotal += row.ReferencceScenario.MEKPerSystem || 0;
  //       }
  //       group.rows.push(row);
  //     }
  //   });

  //   // Return grouped result as array
  //   return Array.from(groups.values());
  // }

  // calculateMekPerSystemForRow(row, allRows) {
  //   if (row.Component === row.Material) {
  //     let total = 0;
  //     let count = 0;
  //     allRows.forEach(n => {
  //       if (
  //         n.Assembly === row.Assembly &&
  //         n.VBLO === row.VBLO &&
  //         n.Component === row.Component &&
  //         n.Component !== n.Material
  //       ) {
  //         count++;
  //         total += n.ReferencceScenario?.MEKPerSystem || 0;
  //       }
  //     });
  //     if (count === 0) {
  //       total = row.ReferencceScenario.MEKsPerPiece * row.ReferencceScenario.Quantity * row.ReferencceScenario.Weight;
  //     }
  //     return total;
  //   } else {
  //     return row.ReferencceScenario.MEKsPerPiece * row.ReferencceScenario.Quantity * row.ReferencceScenario.Weight;
  //   }
  // }

}
